(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('processed-scheduler-item', {
                parent: 'entity',
                url: '/processed-scheduler-item',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Processed Patient Orders'
                },
                ncyBreadcrumb: {
                    label: 'Processed Scheduler Item'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/processed-scheduler-item/list/processed-scheduler-item.html',
                        controller: 'ProcessedSchedulerItemController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
